<template>
  <spam-filters-view />
</template>

<script>
import SpamFiltersView from '@/views/services/hosting/shared/email/SpamFiltersView'

// The hosting section's Spam Protection (the threshold score), shown inside an email account.
export default {
  name: 'AccountSpamView',
  components: { SpamFiltersView },
  // Passed down by EmailAccountView, which has already pointed the hosting
  // context at this account's service; declared so it is not left as a DOM
  // attribute on the wrapped component.
  props: {
    service: {
      type: Object,
      required: true,
    },
  },
}
</script>
